<template>
	<footer>
		<div class="footer_top">
			<div class="footer_m">
				<div class="footer_left">
					<div class="footer_logo"><img src="@/assets/images/logo.png" alt=""></div>
					<div class="footer_contact">
<!--						<dd>联系电话：010-56219846</dd>-->
<!--						<dd>邮箱：609741422@qq.com</dd>-->
					</div>
				</div>
				<div class="footer_right">
<!--					<div class="footer_right_nav">-->
<!--						<a href="">出租</a>-->
<!--						<a href="">出售</a>-->
<!--						<a href="">共享办公</a>-->
<!--						<a href="">企业名录</a>-->
<!--						<a href="">百科资讯</a>-->
<!--						<a href="">问答招聘</a>-->
<!--						<a href="">地图找房</a>-->
<!--					</div>-->
					<div class="footer_r_b">
						<div class="footer_ewm" style="width: 400px;">
							<div class="footer_bk_title">关注我们</div>
							<ul>
								<li>
									<img src="@/assets/images/xcx.jpg" alt="">
									<span>小程序</span>
								</li>
                <li style="width: 225px; margin-left: 20px">
                  <img src="@/assets/images/gzh1.jpg" alt="">
                  <span>公众号</span>
                </li>
<!--								<li>-->
<!--									<img src="@/assets/images/ewm.png" alt="">-->
<!--									<span>iPhone</span>-->
<!--								</li>-->
							</ul>
						</div>
						<div class="footer_msg">
							<div class="footer_bk_title">在线留言</div>
							<div class="footer_bk_form">
								<form class="footer_form">
									<input type="text" placeholder="姓名"  v-model="footername">
									<input type="text" placeholder="电话"  v-model="footermobile">
									<textarea placeholder="备注" v-model="footerremark"></textarea>
									<button type="button" @click="footeryuyue();">立即提交</button>
								</form>
							</div>
						</div>
						
					</div>
					
				</div>
			</div>
		</div>
		<div class="footer_bottom">
			<div class="footer_m" style="width: 100%">
				<div class="footer_b_text footer_b_left" style="text-align: center; width: 100%">
					<p>信息产业部备案/许可证编号：<a href="https://beian.miit.gov.cn" target="_blank">浙ICP备2023005765号</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Copyright @ 2023 湖州有房网</p>
          <p>侵权举报：本站所涉内容如存在侵权问题，请权利人与本网站联系删除！</p>
        </div>
<!--				<div class="footer_b_text footer_b_right">-->
<!--					<p>Copyright @ 2023 湖州有房网</p>-->
<!--				</div>-->
<!--        <div class="footer_b_text footer_b_left" onclick="window.open('https://www.nantaihu.com/')" >-->
<!--          <p>侵权举报：本站所涉内容如存在侵权问题，请权利人与本网站联系删除！</p>-->
<!--          <div style="background-color: #E6F3F9">-->
<!--          <img src="@/assets/images/12377.png" >-->
<!--          <img src="@/assets/images/qinquan.gif" style="background-color: #E6F3F9">-->
<!--          </div>-->
<!--        </div>-->


			</div>
		</div>
	</footer>
</template>

<script>
import {ref} from "vue"
import axios from "axios";
import global from "@/global";
export default{

  data(){
    return{
      footermobile:'',
      footername:'',
      footerremark:'',
      globalUrl: global.httpUrl,
    }
  },


  methods:{
    footeryuyue(){
      const that = this;
      const regex = /^1[3456789]\d{9}$/;//使用此正则即可
      if (!regex.test(that.footermobile)){
        that.$message({
          showClose: true,
          message: '请输入正确的手机号',
          type: 'error',
          duration:2000,
          center:true,
          offset:150
        });

        return false;
      }else{
        let data ={'name':that.footername,'mobile':that.footermobile,'remark':that.footerremark};
        axios.get(this.globalUrl +'/api/home/addLiuyan',{
          params: data
        })
            .then(function (response) {
              if (response.data.code == 1) {
                that.$message({
                  showClose: true,
                  message: '提交成功',
                  type: 'success',
                  duration:2000,
                  center:true,
                  offset:150
                });

                that.$router.go(0)
              }
            })
            .catch(function (error) {
                  console.log(error);
                }
            );
      }
    },

  }

}
</script>
<style>
	.links{
		width: 100%;
		padding: 50px 0;
		position: relative;
		overflow: hidden;
		background: #171516;
	}
	.links_m{
		width: 1200px;
		position: relative;
		margin: auto;
		display: -ms-flexbox;
		display: flex;
		-ms-flex-wrap: wrap;
		flex-wrap: wrap;
		-webkit-justify-content: space-between;
		justify-content: space-between;
	}
	.links_left{
		position: relative;
		overflow: hidden;
		width: 600px;
	}
	.links_left_title{
		width: 100%;
		font-size: 24px;
		color: #ffffff;
	}
	.links_left_a{
		width: 100%;
		margin-top: 20px;
	}
	.links_left_a a{
		font-size: 16px;
		color: #ffffff;
		line-height: 24px;
		margin-right: 18px;
	}
	.links_left_a a:hover{
		color: #FF9D66;
	}
	.links_right{
		margin-top: 20px;
		width: 582px;
		display: -ms-flexbox;
		display: flex;
		-ms-flex-wrap: wrap;
		flex-wrap: wrap;
		-webkit-justify-content: space-between;
		justify-content: space-between;
	}
	.links_right dd{
		width: 48%;
		height: 52px;
		text-align: center;
		line-height: 50px;
		border: solid 1px #ffffff;
		overflow: hidden;
		-o-transition: all 0.5s;
		-moz-transition: all 0.5s;
		-ms-transition: all 0.5s;
		-webkit-transition: all 0.5s;
		transition: all 0.5s;
	}
	.links_right dd a{
		width: 100%;
		height: 100%;
		display: block;
		font-size: 18px;
		color: #ffffff;
		-o-transition: all 0.5s;
		-moz-transition: all 0.5s;
		-ms-transition: all 0.5s;
		-webkit-transition: all 0.5s;
		transition: all 0.5s;
	}
	.links_right dd:hover{
		background: #ffffff;
	}
	.links_right dd:hover a{
		color: #000;
	}
	
	footer{
		background: url(@/assets/images/footer.jpg) top center no-repeat;
		background-size: cover;
		position: relative;
		overflow: hidden;
	}
	.footer_top{
		width: 100%;
		position: relative;
		/*padding-top: 80px;*/
		padding-bottom: 60px;
	}
	.footer_m{
		width: 1200px;
		margin: auto;
		position: relative;
		overflow: hidden;
		display: -ms-flexbox;
		display: flex;
		-ms-flex-wrap: wrap;
		flex-wrap: wrap;
		-webkit-justify-content: space-between;
		justify-content: space-between;
	}
	.footer_left{
		width: 280px;
	}
	.footer_logo{
		width: 100%;
		margin-top: 70px;
		overflow: hidden;
		position: relative;
	}
	.footer_logo img {
    max-width: 44%;
    margin-top: 63px;
}
	.footer_contact{
		width: 100%;
		margin-top: 60px;
	}
	.footer_contact dd{
		margin: 10px 0;
		width: 100%;
		font-size: 16px;
		color: #ffffff;
		line-height: 24px;
	}
	.footer_right{
		width: 880px;
	}
	.footer_right_nav{
		position: relative;
		width: 100%;
		display: -ms-flexbox;
		display: flex;
		-ms-flex-wrap: wrap;
		flex-wrap: wrap;
		-webkit-justify-content: space-between;
		justify-content: space-between;
	}
	.footer_right_nav a{
		font-size: 15px;
		color: #7D7D7D;
		line-height: 24px;
	}
	.footer_right_nav a:hover{
		color: #ffffff;
	}
	.footer_r_b{
		width: 100%;
		position: relative;
		margin-top: 70px;
		display: -ms-flexbox;
		display: flex;
		-ms-flex-wrap: wrap;
		flex-wrap: wrap;
		-webkit-justify-content: space-between;
		justify-content: space-between;
	}
	.footer_ewm{
		width: 260px;
	}
	.footer_bk_title{
		width: 100%;
		font-size: 20px;
		color: #ffffff;
		line-height: 24px;
		margin-bottom: 30px;
		font-weight: bold;
	}
	.footer_ewm ul{
		width: 100%;
		display: -ms-flexbox;
		display: flex;
		-ms-flex-wrap: wrap;
		flex-wrap: wrap;
		-webkit-justify-content: space-between;
		justify-content: space-between;
	}
	.footer_ewm ul li{
		width: 120px;
		text-align: center;
	}
	.footer_ewm ul li img{
		width: 100%;
	}
	.footer_ewm ul li span{
		color: #ffffff;
		font-size: 14px;
		line-height: 24px;
	}
	
	.footer_msg{
		width: 380px;
	}
	.footer_form{
		width: 100%;
	}
	.footer_form input{
		width: 100%;
		height: 40px;
		border: solid 1px #EEEEEE;
		background: no-repeat;
		padding: 0 15px;
		margin-bottom: 8px;
		color: #eeeeee;
		font-size: 14px;
	}
	.footer_form input::placeholder{
		color: #eeeeee;
		font-size: 14px;
	}
	.footer_form textarea{
		width: 100%;
		height: 60px;
		border: solid 1px #EEEEEE;
		background: no-repeat;
		padding: 10px 15px;
		margin-bottom: 8px;
		color: #eeeeee;
		font-size: 14px;
	}
	.footer_form textarea::placeholder{
		color: #eeeeee;
		font-size: 14px;
	}
	.footer_form button{
		width: 100%;
		background: #FFBF9C;
		color: #ffffff;
		font-size: 16px;
		cursor: pointer;
		border: none;
		padding: 10px 0;
	}
	.footer_form button:active{
		opacity: 0.8;
	}
	.footer_bottom{
		width: 100%;
		border-top: solid 1px #ededed;
		position: relative;
		overflow: hidden;
		padding: 25px 0;
	}
	.footer_b_text{
    font-weight:600;
		font-size: 18px;
		color: #797979;
		line-height: 26px;
	}
	.footer_b_text a{
		color: #797979;
	}
	.footer_b_text a:hover{
		color: #FF9D66;
	}
	.footer_b_left{
		width: 60%;
	}
	.footer_b_right{
		display: inline-block;
		text-align: right;
	}

</style>